import type {NavigationMode} from "./BridgeBarData";

/**
 * Maps a NavigationMode to an HTML anchor `target`. Missing/unknown modes default
 * to `_top` (legacy navigation-mode parity). Shared by the App Switcher and the
 * side-nav so both honor the same mapping.
 */
export function modeToTarget(mode: NavigationMode | undefined): string {
  switch (mode) {
    case "NEW_WINDOW":
      return "_blank";
    case "CURRENT_WINDOW":
      return "_self";
    case "TOP_WINDOW":
      return "_top";
    case "PARENT_WINDOW":
      return "_parent";
    default:
      return "_top";
  }
}
